import { format } from 'date-fns'

export const getFactsheetDate = (date: Date) => {
  const currentYear = format(date, 'yyyy')
  const currentMonth = format(date, 'M')

  const previousMonth = currentMonth === '1' ? '12' : String(Number(currentMonth) - 1)
  const year = currentMonth === '1' ? String(Number(currentYear) - 1) : currentYear

  const lastDayOfPreviousMonth = new Date(Number(year), Number(previousMonth), 0)
  const formattedDate = format(lastDayOfPreviousMonth, 'dd MMMM yyyy')

  return { displayDate: formattedDate, month: previousMonth, year }
}
